<div class="customers-page__main">
  <div class="customers-page__title">
    <div class="customers-page-title vox-heading-3" translate>customers.title</div>
  </div>
  <vov-customers-table (onLoginCustomer)="loginCustomer($event)"></vov-customers-table>
</div>
